import React from 'react';
import styles from './CopyToast.module.scss';

interface Props {
  show: boolean;
  text: string;
  icon: React.ReactNode;
}

const CopyToast = ({ show, text, icon }: Props) => {
  return (
    <div className={`${styles.copyToast} ${show ? styles.show : ''}`}>
      {icon}
      <span>{text}</span>
    </div>
  );
};

export default CopyToast;
